/**
 * App names whose host page owns the AEM shell right drawer, reachable through
 * window['rightdrawerCompAlRef'].
 *
 * Single source of truth for product-coupon-al-v1 and product-coupon-al-v2. Both
 * components dispatch the same drawer payload and previously carried this
 * allowlist as duplicated inline predicates — one side was updated and the other
 * missed, which is how ACIP-605408 reached production.
 *
 * Entries are stored lowercase and compared case-insensitively. Consumers emit
 * inconsistent casing for the same app ('b4uspa' on the discovery carousel,
 * 'b4uSPA' on my-list), and an exact-match miss fails silently: the dispatch
 * falls back to CommonService.rightDrawerSource, which has no subscriber in
 * consumers that rely on the shell drawer. No error, no drawer.
 */
export const SHELL_DRAWER_APP_NAMES: ReadonlySet<string> = new Set([
    'b4uspa',
    'b4u-offerdetails',
]);

/**
 * True when configObj.appName belongs to an app that owns the AEM shell right
 * drawer. Case-insensitive, and safe when appName is undefined.
 */
export function isShellDrawerApp(appName?: string): boolean {
    return !!appName && SHELL_DRAWER_APP_NAMES.has(appName.toLowerCase());
}
